import * as staticUrls from "../constants/static-urls";
import {SalaryCalculatorFormData} from "../layouts/salary-calculator-form-block/salary-calculator-form";
import {EmployeeSalaryInfoData} from "../models/employee-salary-info-data";

export const handleGenerateStaffCalculation = (formData: SalaryCalculatorFormData): Promise<EmployeeSalaryInfoData> | null => {
    // PRZYGOTOWYWANIE REQUESTA
    const request: SalaryCalculatorFormData = {
        salaryValue: Number(formData.salaryValue),
        employmentType: formData.employmentType,
        employmentInPlaceOfResidence: formData.employmentInPlaceOfResidence == "true",
        socialSecurityPPKBaseTitle: formData.socialSecurityPPKBaseTitle == "true",
        taxFreeAllowance: formData.taxFreeAllowance == "true",
        taxFreeAllowanceForYoungPeople: formData.taxFreeAllowanceForYoungPeople  == "true",
        socialSecurityRetirementTitle: formData.socialSecurityRetirementTitle == "true",
        socialSecurityDisabilityTitle: formData.socialSecurityDisabilityTitle == "true",
        socialSecurityIllnessTitle: formData.socialSecurityIllnessTitle == "true",
        socialSecurityAccidentTitle: formData.socialSecurityAccidentTitle == "true",
        socialSecurityHealthTitle: formData.socialSecurityHealthTitle == "true",
        socialSecurityArt83Exemption: formData.socialSecurityArt83Exemption == "true",
        socialSecurityLabourFundTitle: formData.socialSecurityLabourFundTitle == "true",
        socialSecurityEmployeeBenefitsTitle: formData.socialSecurityEmployeeBenefitsTitle == "true"
    };

    // FETCHOWANIE
    return fetch(staticUrls.FAKTUROMANIA_STAFF_CALCULATOR_API_URL,{
        body: JSON.stringify(request),
        headers: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": "application/json"
        },
        method: "POST"
    })
        .then(response => {
            // JEŚLI NIE WSZYSTKO JEST OK!
            if (!response.ok) {
                throw new Error(`Błąd HTTP: ${response.status}`);
            }

            // JEŚLI WSZYSTKO JEST OK
            return response.json();
        })
        // JEŚLI ERROR
        .catch(error => {
            console.error("Błąd pobierania:", error);
            return null;
        });
}


// WEBPACK FOOTER //
// ./src/services/staff-calculator-service.ts